import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'brand-strava', 'IconBrandStrava', [["path",{"d":"M15 13l-5 -10l-5 10m6 0l4 8l4 -8","key":"svg-0"}]]);